import Button from "components/Button/Button";
import KakaoBtn from "components/KakaoBtn/KakaoBtn";
import { youtubeButton } from "lib/image";
import { useCallback, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { appData, testResultSelector } from "recoil/app";
import style from "./Result.module.scss";
type Props = {};

const url = `https://script.google.com/macros/s/AKfycbxcsaH3OBNxXDDlZZzDKttMMfwMT-_EEYisYzBh7F_W8sMFX0WwutRjjpjIlaImTqoAEQ/exec`;

const Result = (props: Props) => {
  const { theme } = useRecoilValue(appData);
  const resultData = useRecoilValue(testResultSelector);
  const onClickRestart = useCallback(() => {
    // window.location.reload();
    window.location.href = window.location.origin;
  }, []);

  const onClickYoutube = () => {
    window.open(
      "https://www.youtube.com/channel/UCP2ITwAGdX8LAADPX2jVltQ",
      "_blank"
    );
  };

  useEffect(() => {
    if (window.location.search === "") {
      fetch(
        `${url}?시간=${new Date().toLocaleDateString()}&결과=${resultData.id}`
      );
    }
  }, []);

  return (
    <div
      className={style.container}
      data-aos={"fade-up"}
      data-aos-duartion="1500"
    >
      <section
        style={{
          backgroundImage: `url('${
            process.env.PUBLIC_URL + `/assets/img/result${resultData.id}.png`
          }')`,
        }}
        className={style.head}
      ></section>
      <section className={style.result}>
        <div className={style.result_inner}>
          <div style={{ color: theme?.accent }} className={style.mainTitle}>
            {resultData.result}
          </div>
          <div className={style.summary}>"{resultData.summary}"</div>
          <div className={style.descript_wrapper}>
            {resultData.descript.map((it, idx) => (
              <div className={style.descript} key={`descript_${idx}`}>
                - {it}
              </div>
            ))}
          </div>
          <section className={style.footer}>
            <Button onClick={onClickYoutube}>
              <img src={youtubeButton} />
            </Button>
            <Button onClick={onClickRestart}>{"다시하기"}</Button>
            <KakaoBtn />
          </section>
        </div>
      </section>
    </div>
  );
};

export default Result;
